import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

export default function Copyright() {
  const year = new Date().getFullYear()
  const strPre = `© ${year} `
  const linkText = 'N2K Networks, Inc.'
  const linkUrl = 'https://www.n2k.com/'
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {strPre}
      <Link color="inherit" href={linkUrl}>
        {linkText}
      </Link>
    </Typography>
  )
}
